module.exports = __webpack_public_path__ + "static/img/2.20fc889.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f1/2.gif
// module id = 8YQ+
// module chunks = 1